import websitesReducer from "./websitesSlice";

export default websitesReducer;
